import React, { useState } from "react";
import get from "lodash/get";
import set from "@rill/set";

import SettingsNav from "../../../parts/settings-nav";

import {
  getRoleNameById,
  getUserToRequest,
} from "./manage-coaches/utils/manage-coaches-utils";

import { round } from "lodash";

import VelocityExplanation from "../../../parts/modals/velocity-explanation";
import GeneralPreferences from "./GeneralPreferences";
import PullPreferences from "./PullPreferences";
import PressPreferences from "./PressPreferences";
import PushPreferences from "./PushPreferences";
import { SettingsBackHandler } from "../../coaching-portal/settings/components/SettingsBackHandler";
import {
  calculateFreeTrialDaysLeft,
  isCoachConverted,
  isCoachFreeTrial,
} from "../../../utils/user-helpers";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const LIFTING_STANDARDS = {
  squat: 0.23,
  bench: 0.1,
  deadlift: 0.14,
};

function View(props, { locals }) {
  const {
    activeUser,
    units: activeUserUnits,
    organizationOwner,
    organizationRoles,
  } = locals;
  //if the user have a role, get the role, if not, the default value should be owner
  const roleName = !!activeUser.organizationRoleId
    ? getRoleNameById(organizationRoles, activeUser.organizationRoleId)
    : "Owner";
  const isAdminOrOwner = roleName === "Owner" || roleName === "Admin";
  //check if user is NOT able to edit information
  const notAbleToEdit =
    !!activeUser.organizationId && !!organizationOwner && !isAdminOrOwner;
  const isCoach =
    activeUser.permissions.includes("coach") &&
    !(!organizationOwner && !isCoachConverted(activeUser));
  const isExpiredPull =
    isCoachFreeTrial(activeUser) && calculateFreeTrialDaysLeft(activeUser) < 1;
  //retrive the user information from current user or organizationOwner
  const userToBindInformation =
    roleName === "Owner" ? activeUser : organizationOwner;
  //send the user information from current user or organizationOwner
  const userToSendInformation =
    roleName !== "Admin" ? activeUser._id : organizationOwner._id;
  const isFe = Boolean(userToBindInformation.pushAccountInfo);
  const startingCalendarDay = activeUser.startingCalendarDay || 0;
  const activeUserRound = Boolean(get(userToBindInformation, "round"));
  const isPressCoach = Boolean(userToBindInformation.pressAccountInfo);
  const isPushCoach = Boolean(userToBindInformation.pushAccountInfo);
  const hideRepMaximums = Boolean(userToBindInformation.hideRepMaximums);
  const intensityMeasure = userToBindInformation.intensityMeasure || "rpe";
  const hideStrengthMetrics = Boolean(
    userToBindInformation.hideStrengthMetrics
  );
  const hideE1rm = Boolean(userToBindInformation.hideE1rm);
  const chatEnabled = Boolean(activeUser.chatEnabled || false);
  const referAsClients = Boolean(activeUser.referAsClients || false);
  const manualMembership = Boolean(
    userToBindInformation.manualMembership || false
  );

  const [hideVelocitySettings, setHideVelocitySettings] = useState(
    Boolean(userToBindInformation.hideVelocitySettings !== false)
  );

  const velocityThresholds = activeUser.velocityThresholds || null;

  const [thresholds, setThresholds] = useState({
    squat: velocityThresholds
      ? velocityThresholds.squat - LIFTING_STANDARDS.squat
      : 0,
    bench: velocityThresholds
      ? velocityThresholds.bench - LIFTING_STANDARDS.bench
      : 0,
    deadlift: velocityThresholds
      ? velocityThresholds.deadlift - LIFTING_STANDARDS.deadlift
      : 0,
  });

  return (
    <main className="settings">
      <SettingsNav classNames={"mobile-hidden"} />
      <section className="preferences-wrapper">
        <h3 className="force-mobile-hidden">Preferences</h3>
        <SettingsBackHandler title={"Preferences"} />
        <nav role="tablist">
          <a
            href="/actions/refresh?type=general"
            aria-current={
              !locals.query.type || locals.query.type === "general" || undefined
            }
          >
            General
          </a>
          {!!isCoach && !isExpiredPull && (
            <a
              href="/actions/refresh?type=pull"
              aria-current={locals.query.type === "pull" || undefined}
            >
              PULL
            </a>
          )}
          {isPushCoach && !notAbleToEdit && (
            <a
              href="/actions/refresh?type=push"
              aria-current={locals.query.type === "push" || undefined}
            >
              PUSH
            </a>
          )}
          {isPressCoach && !notAbleToEdit && (
            <a
              href="/actions/refresh?type=press"
              aria-current={locals.query.type === "press" || undefined}
            >
              PRESS
            </a>
          )}
        </nav>

        {locals.query.type === "push" && (
          <PushPreferences
            locals={locals}
            showTab={locals.query.type === "push"}
            userToSendInformation={userToSendInformation}
          />
        )}
        {(!locals.query.type || locals.query.type === "general") && (
          <GeneralPreferences
            userToSendInformation={userToSendInformation}
            roleName={roleName}
            activeUserUnits={activeUserUnits}
            startingCalendarDay={startingCalendarDay}
            notAbleToEdit={notAbleToEdit}
            activeUserRound={activeUserRound}
            isFe={isFe}
            isCoach={isCoach}
            hideRepMaximums={hideRepMaximums}
            userToBindInformation={userToBindInformation}
            hideStrengthMetrics={hideStrengthMetrics}
            hideE1rm={hideE1rm}
            intensityMeasure={intensityMeasure}
            referAsClients={referAsClients}
            chatEnabled={chatEnabled}
            manualMembership={manualMembership}
            isPressCoach={isPressCoach}
            hideVelocitySettings={hideVelocitySettings}
            setHideVelocitySettings={setHideVelocitySettings}
            thresholds={thresholds}
            setThresholds={setThresholds}
            showTab={!locals.query.type || locals.query.type === "general"}
            isOrganization={Boolean(activeUser.organizationId)}
          />
        )}
        {locals.query.type === "pull" && (
          <PullPreferences
            isFe={isFe}
            isCoach={isCoach}
            referAsClients={referAsClients}
            chatEnabled={chatEnabled}
            userToSendInformation={userToSendInformation}
            roleName={roleName}
          />
        )}
        {locals.query.type === "press" && (
          <PressPreferences
            isPressCoach={isPressCoach}
            manualMembership={manualMembership}
            userToSendInformation={userToSendInformation}
          />
        )}

        <footer>
          <button
            data-button-type="primary"
            form={`form-${locals.query.type || "general"}`}
            type="submit"
          >
            Save
          </button>
        </footer>
      </section>
    </main>
  );
}

/**
 * This function is to call it when the setting is for the general, pull and press tav
 * @param {*} body
 * @param {*} locals
 * @param {*} api
 * @param {*} assert
 */
const handlePreferencesPost = async (body, locals, api, assert) => {
  const { activeUser, organizationOwner } = locals;
  //retrive the user information from current user or organizationOwner
  const userToBindInformation =
    body.roleName === "Owner" ? activeUser : organizationOwner;
  const isFe = Boolean(userToBindInformation?.pushAccountInfo);
  const isCoach = activeUser.permissions.includes("coach");

  // To make sure only coaches with access to the velocity settings get updated
  if (!!(isFe || isCoach)) {
    const {
      deadliftThreshold,
      benchThreshold,
      squatThreshold,
      timeMinutesDefault,
      timeSecondsDefault,
    } = body;
    // REST TIMES

    // Null in case the user doesn't update the default (which is null as well) so the time isn't stored as a 0
    const defaultTime = timeSecondsDefault + timeMinutesDefault * 60 || null;

    // Delete the input information from the body in case it causes conflicts with the api
    delete body.timeSecondsDefault;
    delete body.timeMinutesDefault;

    // This loop will get the values from the body and create the reps time object
    // It will also delete the input information from the body
    // the object looks like this:
    // reps = {
    //   rep1: 67,
    //   rep2: null,
    //   ...
    //   rep12: 114
    // }
    const reps = {};
    for (let i = 1; i < 13; i++) {
      const minutes = body[`timeMinutes${i}`];
      const seconds = body[`timeSeconds${i}`];
      reps[`rep${i}`] = seconds + minutes * 60 || null;
      delete body[`timeMinutes${i}`];
      delete body[`timeSeconds${i}`];
    }

    const restTime = {
      default: defaultTime,
      reps,
    };

    body.restTime = restTime;

    if (body.hideVelocitySettings) {
      // Consequences of poor planning for hiding the velocity settings
      // Now we have to reverse the value of the input here or it will destroy everything
      body.hideVelocitySettings = false;

      // VELOCITY
      const velocityThresholds = {
        squat: round(LIFTING_STANDARDS.squat + squatThreshold, 2),
        bench: round(LIFTING_STANDARDS.bench + benchThreshold, 2),
        deadlift: round(LIFTING_STANDARDS.deadlift + deadliftThreshold, 2),
      };

      body.velocityThresholds = velocityThresholds;
    } else {
      body.hideVelocitySettings = true;
    }

    delete body.deadliftThreshold;
    delete body.benchThreshold;
    delete body.squatThreshold;

    if (body.collectRepMax) {
      body.collectRepMax = Object.keys(body.collectRepMax);
    }
  }

  body.action = "updateUserPreferences";
  //user to send the info (current or owner of the organization)
  const userToUpdate = body.userToSendInformation;
  //check if the user is admin or owner
  const isAdmin = body.roleName === "Admin";
  const isOwner = body.roleName === "Owner";
  //delete irrelevant information
  delete body.roleName;
  delete body.userToSendInformation;

  //if chatEnabled was already true and the user saves the preferences without turn off the chat we are going to delete
  //the property for the body to not call needlessly the processCoach method in the msb-chat-script-main project
  if (locals.activeUser.chatEnabled && body.chatEnabled) {
    delete body.chatEnabled;
  }
  //if the user is admin, we are going to send units, chat and startingCalendarDay from admin and the rest of the information would be for owner
  if (isAdmin) {
    const adminBody = {
      units: body.units,
      startingCalendarDay: body.startingCalendarDay,
    };
    if (body.chatEnabled !== undefined) {
      adminBody.chatEnabled = body.chatEnabled;
    }
    delete body.units;
    delete body.startingCalendarDay;
    delete body.chatEnabled;
    await api(`user/${locals.activeUser._id}`, {
      method: "PUT",
      body: adminBody,
    });
  }
  if ((isAdmin || isOwner) && activeUser.organizationId) {
    const {
      hideVelocitySettings,
      hideStrengthMetrics,
      hideRepMaximums,
      hideE1rm,
      intensityMeasure,
      restTime,
      round,
      preferredLoadInput,
      collectRepMax,
    } = body;

    const organizationBody = {
      ownerId: userToUpdate,
      ...Object.fromEntries(
        Object.entries({
          hideVelocitySettings,
          hideStrengthMetrics,
          hideRepMaximums,
          hideE1rm,
          intensityMeasure,
          restTime,
          round,
          preferredLoadInput,
          collectRepMax,
        }).filter(([_, value]) => value != null)
      ),
    };

    try {
      await api(`user/${userToUpdate}`, {
        method: "PUT",
        body,
      });
      await api(`update-organization-general-preferences`, {
        method: "PUT",
        body: organizationBody,
      });
    } catch (error) {
      console.error("error updating an organization", error);
    }
  } else {
    await api(`user/${userToUpdate}`, {
      method: "PUT",
      body,
    });
  }
};

const handleStoreFrontPost = async (body, locals, api, assert) => {
  const { activeUser, organizationOwner } = locals;
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const { customBranding = {}, pushAccountInfo = {} } = userToRequest;
  let newBody = {};

  const {
    externalCommunityEnabled = false,
    inAppCommunityEnabled = false,
    communityLink = "",
    global = "",
    paymentSuccess = "",
  } = body;

  newBody.customBranding = { ...customBranding };

  // User has permissions to update the snippets
  if (customBranding?.storefrontSnippets?.active) {
    newBody.customBranding.storefrontSnippets = {
      active: true,
      ...(global && { global }),
      ...(paymentSuccess && { paymentSuccess }),
    };
  } else if (global.length > 0 || paymentSuccess.length > 0) {
    // Throw an error if the user doesn't have permissions to update the snippets and he/she decided to modify it
    assert(false, 400, "Ask for permissions in order to update the scripts");
  }

  //Update the community options
  if (pushAccountInfo && Object.keys(pushAccountInfo).length > 0) {
    newBody = {
      ...newBody,
      pushAccountInfo: {
        ...pushAccountInfo,
        inAppCommunityEnabled,
        externalCommunityEnabled,
      },
      customBranding: {
        ...newBody.customBranding,
        ...(communityLink !== undefined && { communityLink }),
      },
    };
  }

  await api(`user/${userToRequest._id}`, {
    method: "PUT",
    body: newBody,
  });
};

const PreferencesController = (app) => {
  app
    .get(
      "/preferences",
      set("heading", "Preferences"),
      async ({ res, req, load, locals }) => {
        const { query } = req;
        const modal = query.modal || {};

        locals.modal = {
          "velocity-explanation": <VelocityExplanation />,
          "activity-feed": <ActivityDrawer />,
        }[modal.type];

        res.body = <View />;
      }
    )
    .post("/preferences", async ({ req, locals, res, api, flash, assert }) => {
      const { body } = req;
      const { search } = locals;
      const isPushPreference = search?.includes("push");

      try {
        if (isPushPreference) {
          await handleStoreFrontPost(body, locals, api, assert);
        } else {
          await handlePreferencesPost(body, locals, api, assert);
        }
        flash("success", "Successfully updated");
        res.backDontScroll();
      } catch (e) {
        flash("error", e.message);
        res.backDontScroll();
      }
    });
};

export default PreferencesController;
